import { LocationModel } from "../../shared/common/viewmodels/location.model";
import { ReasonModel } from "../../shared/common/viewmodels/reason.model";

export class AdditionalExplanationViewModel {
  id = 0;
  name = '';
  contravention: number;
  reason = '';
  ricId: number;
  locationName = '';
  locationId: number;
  textResourceId: string;
  letterText = '';
  order: number;
  active: boolean = true;
  locations: LocationModel[];
  reasons: ReasonModel[];
  selected: boolean;
  expanded: boolean = false;
}
